export default __webpack_public_path__ + "6315398.png";